import React from 'react';

import PropTypes from 'prop-types';
import { HiOutlineTrash, HiViewGrid } from 'react-icons/hi';

import { Text, Button } from 'modules/common';
import { downloadGet } from 'modules/common/utils';

function Bar({
  withViewGallery,
  fileName,
  fileSize,
  fileUrl,
  onViewGallery,
  onDelete,
  onDownload,
  withDelete,
  withDownload,
  onClose,
  selectedIndex,
  onSelect,
  withSelect,
}) {
  const handleOnDownload = () => {
    if (!onDownload && fileUrl) {
      downloadGet({
        url: fileUrl,
        isImage: true,
        filename: fileName || 'untitled',
      });

      return;
    }

    if (typeof onDownload === 'function') {
      onDownload();
    }
  };

  return (
    <div className="flex items-center">
      <div className="flex items-center gap-ds-16 flex-1">
        {(Boolean(fileName) || Boolean(fileSize)) && (
          <div className="flex items-center gap-ds-16">
            {Boolean(fileName) && (
              <Text type="caption" weight="semibold">
                {fileName}
              </Text>
            )}

            {Boolean(fileSize) && <Text type="caption">{fileSize}</Text>}
          </div>
        )}

        {(Boolean(fileName) || Boolean(fileSize)) && (
          <div className="border-[0.5px] border-default h-ds-16 border-opacity-50" />
        )}

        {withSelect && (
          <Button size="xs" label="Select Photo" onClick={onSelect} />
        )}

        {withDownload && (
          <button
            type="button"
            onClick={handleOnDownload}
            className="text-left flex items-center gap-ds-6"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.4 13.6C2.4 13.1582 2.75817 12.8 3.2 12.8H12.8C13.2418 12.8 13.6 13.1582 13.6 13.6C13.6 14.0418 13.2418 14.4 12.8 14.4H3.2C2.75817 14.4 2.4 14.0418 2.4 13.6ZM5.03432 7.4343C5.34674 7.12188 5.85327 7.12188 6.16569 7.4343L7.2 8.46861L7.2 2.39998C7.2 1.95815 7.55817 1.59998 8 1.59998C8.44183 1.59998 8.8 1.95815 8.8 2.39998V8.46862L9.83432 7.4343C10.1467 7.12188 10.6533 7.12188 10.9657 7.4343C11.2781 7.74672 11.2781 8.25325 10.9657 8.56567L8.56569 10.9657C8.41566 11.1157 8.21217 11.2 8 11.2C7.78783 11.2 7.58435 11.1157 7.43432 10.9657L5.03432 8.56567C4.7219 8.25325 4.7219 7.74672 5.03432 7.4343Z"
                fill="white"
              />
            </svg>

            <Text type="caption" weight="semibold" className="hidden md:block">
              Download
            </Text>
          </button>
        )}

        {withDelete && (
          <button
            type="button"
            onClick={() => onDelete(selectedIndex, onClose)}
            className="text-left flex items-center gap-ds-6"
          >
            <HiOutlineTrash className="h-4 w-4" />

            <Text type="caption" weight="semibold" className="hidden md:block">
              Delete
            </Text>
          </button>
        )}
      </div>

      {withViewGallery && (
        <button
          type="button"
          className="text-left flex items-center gap-ds-8"
          onClick={onViewGallery}
        >
          <HiViewGrid className="h-4 w-4" />

          <Text type="caption" weight="semibold" className="hidden md:block">
            View Gallery
          </Text>
        </button>
      )}
    </div>
  );
}

Bar.defaultProps = {
  fileName: '',
  fileSize: '',
  onViewGallery: () => {},
  onDelete: () => {},
  onClose: () => {},
  onSelect: () => {},
  onDownload: false,
  withViewGallery: true,
  withDelete: true,
  withDownload: true,
  withSelect: false,
  fileUrl: '',
  selectedIndex: null,
};

Bar.propTypes = {
  fileName: PropTypes.string,
  fileSize: PropTypes.string,
  withViewGallery: PropTypes.bool,
  withSelect: PropTypes.bool,
  withDelete: PropTypes.bool,
  withDownload: PropTypes.bool,
  onViewGallery: PropTypes.instanceOf(Function),
  onSelect: PropTypes.instanceOf(Function),
  onDelete: PropTypes.instanceOf(Function),
  onClose: PropTypes.instanceOf(Function),
  onDownload: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.instanceOf(Function),
  ]),
  fileUrl: PropTypes.string,
  selectedIndex: PropTypes.number,
};

export default Bar;
